/**
 * International dial codes for the phone-verification country selector.
 * One entry per unique dial code (flag = the code's principal country).
 * GCC countries first (Kuwait is the default), then A–Z by country name.
 * Israel (+972) is intentionally not included.
 */
export const DIAL_CODES = [
  // --- GCC first ---
  { code: "+965", flag: "🇰🇼", name: "Kuwait", ar: "الكويت" },
  { code: "+966", flag: "🇸🇦", name: "Saudi Arabia", ar: "السعودية" },
  { code: "+971", flag: "🇦🇪", name: "United Arab Emirates", ar: "الإمارات" },
  { code: "+974", flag: "🇶🇦", name: "Qatar", ar: "قطر" },
  { code: "+973", flag: "🇧🇭", name: "Bahrain", ar: "البحرين" },
  { code: "+968", flag: "🇴🇲", name: "Oman", ar: "عُمان" },
  // --- rest of the world ---
  { code: "+93", flag: "🇦🇫", name: "Afghanistan", ar: "أفغانستان" },
  { code: "+355", flag: "🇦🇱", name: "Albania", ar: "ألبانيا" },
  { code: "+213", flag: "🇩🇿", name: "Algeria", ar: "الجزائر" },
  { code: "+376", flag: "🇦🇩", name: "Andorra", ar: "أندورا" },
  { code: "+244", flag: "🇦🇴", name: "Angola", ar: "أنغولا" },
  { code: "+1268", flag: "🇦🇬", name: "Antigua and Barbuda", ar: "أنتيغوا وباربودا" },
  { code: "+54", flag: "🇦🇷", name: "Argentina", ar: "الأرجنتين" },
  { code: "+374", flag: "🇦🇲", name: "Armenia", ar: "أرمينيا" },
  { code: "+61", flag: "🇦🇺", name: "Australia", ar: "أستراليا" },
  { code: "+43", flag: "🇦🇹", name: "Austria", ar: "النمسا" },
  { code: "+994", flag: "🇦🇿", name: "Azerbaijan", ar: "أذربيجان" },
  { code: "+1242", flag: "🇧🇸", name: "Bahamas", ar: "الباهاما" },
  { code: "+880", flag: "🇧🇩", name: "Bangladesh", ar: "بنغلاديش" },
  { code: "+1246", flag: "🇧🇧", name: "Barbados", ar: "باربادوس" },
  { code: "+375", flag: "🇧🇾", name: "Belarus", ar: "بيلاروسيا" },
  { code: "+32", flag: "🇧🇪", name: "Belgium", ar: "بلجيكا" },
  { code: "+501", flag: "🇧🇿", name: "Belize", ar: "بليز" },
  { code: "+229", flag: "🇧🇯", name: "Benin", ar: "بنين" },
  { code: "+975", flag: "🇧🇹", name: "Bhutan", ar: "بوتان" },
  { code: "+591", flag: "🇧🇴", name: "Bolivia", ar: "بوليفيا" },
  { code: "+387", flag: "🇧🇦", name: "Bosnia and Herzegovina", ar: "البوسنة والهرسك" },
  { code: "+267", flag: "🇧🇼", name: "Botswana", ar: "بوتسوانا" },
  { code: "+55", flag: "🇧🇷", name: "Brazil", ar: "البرازيل" },
  { code: "+673", flag: "🇧🇳", name: "Brunei", ar: "بروناي" },
  { code: "+359", flag: "🇧🇬", name: "Bulgaria", ar: "بلغاريا" },
  { code: "+226", flag: "🇧🇫", name: "Burkina Faso", ar: "بوركينا فاسو" },
  { code: "+257", flag: "🇧🇮", name: "Burundi", ar: "بوروندي" },
  { code: "+855", flag: "🇰🇭", name: "Cambodia", ar: "كمبوديا" },
  { code: "+237", flag: "🇨🇲", name: "Cameroon", ar: "الكاميرون" },
  { code: "+1", flag: "🇺🇸", name: "United States / Canada", ar: "الولايات المتحدة / كندا" },
  { code: "+238", flag: "🇨🇻", name: "Cape Verde", ar: "الرأس الأخضر" },
  { code: "+236", flag: "🇨🇫", name: "Central African Republic", ar: "أفريقيا الوسطى" },
  { code: "+235", flag: "🇹🇩", name: "Chad", ar: "تشاد" },
  { code: "+56", flag: "🇨🇱", name: "Chile", ar: "تشيلي" },
  { code: "+86", flag: "🇨🇳", name: "China", ar: "الصين" },
  { code: "+57", flag: "🇨🇴", name: "Colombia", ar: "كولومبيا" },
  { code: "+269", flag: "🇰🇲", name: "Comoros", ar: "جزر القمر" },
  { code: "+242", flag: "🇨🇬", name: "Congo", ar: "الكونغو" },
  { code: "+243", flag: "🇨🇩", name: "DR Congo", ar: "الكونغو الديمقراطية" },
  { code: "+506", flag: "🇨🇷", name: "Costa Rica", ar: "كوستاريكا" },
  { code: "+385", flag: "🇭🇷", name: "Croatia", ar: "كرواتيا" },
  { code: "+53", flag: "🇨🇺", name: "Cuba", ar: "كوبا" },
  { code: "+357", flag: "🇨🇾", name: "Cyprus", ar: "قبرص" },
  { code: "+420", flag: "🇨🇿", name: "Czechia", ar: "التشيك" },
  { code: "+45", flag: "🇩🇰", name: "Denmark", ar: "الدنمارك" },
  { code: "+253", flag: "🇩🇯", name: "Djibouti", ar: "جيبوتي" },
  { code: "+1767", flag: "🇩🇲", name: "Dominica", ar: "دومينيكا" },
  { code: "+1809", flag: "🇩🇴", name: "Dominican Republic", ar: "جمهورية الدومينيكان" },
  { code: "+593", flag: "🇪🇨", name: "Ecuador", ar: "الإكوادور" },
  { code: "+20", flag: "🇪🇬", name: "Egypt", ar: "مصر" },
  { code: "+503", flag: "🇸🇻", name: "El Salvador", ar: "السلفادور" },
  { code: "+240", flag: "🇬🇶", name: "Equatorial Guinea", ar: "غينيا الاستوائية" },
  { code: "+291", flag: "🇪🇷", name: "Eritrea", ar: "إريتريا" },
  { code: "+372", flag: "🇪🇪", name: "Estonia", ar: "إستونيا" },
  { code: "+268", flag: "🇸🇿", name: "Eswatini", ar: "إسواتيني" },
  { code: "+251", flag: "🇪🇹", name: "Ethiopia", ar: "إثيوبيا" },
  { code: "+679", flag: "🇫🇯", name: "Fiji", ar: "فيجي" },
  { code: "+358", flag: "🇫🇮", name: "Finland", ar: "فنلندا" },
  { code: "+33", flag: "🇫🇷", name: "France", ar: "فرنسا" },
  { code: "+241", flag: "🇬🇦", name: "Gabon", ar: "الغابون" },
  { code: "+220", flag: "🇬🇲", name: "Gambia", ar: "غامبيا" },
  { code: "+995", flag: "🇬🇪", name: "Georgia", ar: "جورجيا" },
  { code: "+49", flag: "🇩🇪", name: "Germany", ar: "ألمانيا" },
  { code: "+233", flag: "🇬🇭", name: "Ghana", ar: "غانا" },
  { code: "+30", flag: "🇬🇷", name: "Greece", ar: "اليونان" },
  { code: "+1473", flag: "🇬🇩", name: "Grenada", ar: "غرينادا" },
  { code: "+502", flag: "🇬🇹", name: "Guatemala", ar: "غواتيمالا" },
  { code: "+224", flag: "🇬🇳", name: "Guinea", ar: "غينيا" },
  { code: "+245", flag: "🇬🇼", name: "Guinea-Bissau", ar: "غينيا بيساو" },
  { code: "+592", flag: "🇬🇾", name: "Guyana", ar: "غيانا" },
  { code: "+509", flag: "🇭🇹", name: "Haiti", ar: "هايتي" },
  { code: "+504", flag: "🇭🇳", name: "Honduras", ar: "هندوراس" },
  { code: "+36", flag: "🇭🇺", name: "Hungary", ar: "المجر" },
  { code: "+354", flag: "🇮🇸", name: "Iceland", ar: "آيسلندا" },
  { code: "+91", flag: "🇮🇳", name: "India", ar: "الهند" },
  { code: "+62", flag: "🇮🇩", name: "Indonesia", ar: "إندونيسيا" },
  { code: "+98", flag: "🇮🇷", name: "Iran", ar: "إيران" },
  { code: "+964", flag: "🇮🇶", name: "Iraq", ar: "العراق" },
  { code: "+353", flag: "🇮🇪", name: "Ireland", ar: "أيرلندا" },
  { code: "+39", flag: "🇮🇹", name: "Italy", ar: "إيطاليا" },
  { code: "+225", flag: "🇨🇮", name: "Ivory Coast", ar: "ساحل العاج" },
  { code: "+1876", flag: "🇯🇲", name: "Jamaica", ar: "جامايكا" },
  { code: "+81", flag: "🇯🇵", name: "Japan", ar: "اليابان" },
  { code: "+962", flag: "🇯🇴", name: "Jordan", ar: "الأردن" },
  { code: "+7", flag: "🇰🇿", name: "Kazakhstan / Russia", ar: "كازاخستان / روسيا" },
  { code: "+254", flag: "🇰🇪", name: "Kenya", ar: "كينيا" },
  { code: "+686", flag: "🇰🇮", name: "Kiribati", ar: "كيريباتي" },
  { code: "+82", flag: "🇰🇷", name: "South Korea", ar: "كوريا الجنوبية" },
  { code: "+383", flag: "🇽🇰", name: "Kosovo", ar: "كوسوفو" },
  { code: "+996", flag: "🇰🇬", name: "Kyrgyzstan", ar: "قيرغيزستان" },
  { code: "+856", flag: "🇱🇦", name: "Laos", ar: "لاوس" },
  { code: "+371", flag: "🇱🇻", name: "Latvia", ar: "لاتفيا" },
  { code: "+961", flag: "🇱🇧", name: "Lebanon", ar: "لبنان" },
  { code: "+266", flag: "🇱🇸", name: "Lesotho", ar: "ليسوتو" },
  { code: "+231", flag: "🇱🇷", name: "Liberia", ar: "ليبيريا" },
  { code: "+218", flag: "🇱🇾", name: "Libya", ar: "ليبيا" },
  { code: "+423", flag: "🇱🇮", name: "Liechtenstein", ar: "ليختنشتاين" },
  { code: "+370", flag: "🇱🇹", name: "Lithuania", ar: "ليتوانيا" },
  { code: "+352", flag: "🇱🇺", name: "Luxembourg", ar: "لوكسمبورغ" },
  { code: "+261", flag: "🇲🇬", name: "Madagascar", ar: "مدغشقر" },
  { code: "+265", flag: "🇲🇼", name: "Malawi", ar: "مالاوي" },
  { code: "+60", flag: "🇲🇾", name: "Malaysia", ar: "ماليزيا" },
  { code: "+960", flag: "🇲🇻", name: "Maldives", ar: "المالديف" },
  { code: "+223", flag: "🇲🇱", name: "Mali", ar: "مالي" },
  { code: "+356", flag: "🇲🇹", name: "Malta", ar: "مالطا" },
  { code: "+692", flag: "🇲🇭", name: "Marshall Islands", ar: "جزر مارشال" },
  { code: "+222", flag: "🇲🇷", name: "Mauritania", ar: "موريتانيا" },
  { code: "+230", flag: "🇲🇺", name: "Mauritius", ar: "موريشيوس" },
  { code: "+52", flag: "🇲🇽", name: "Mexico", ar: "المكسيك" },
  { code: "+691", flag: "🇫🇲", name: "Micronesia", ar: "ميكرونيزيا" },
  { code: "+373", flag: "🇲🇩", name: "Moldova", ar: "مولدوفا" },
  { code: "+377", flag: "🇲🇨", name: "Monaco", ar: "موناكو" },
  { code: "+976", flag: "🇲🇳", name: "Mongolia", ar: "منغوليا" },
  { code: "+382", flag: "🇲🇪", name: "Montenegro", ar: "الجبل الأسود" },
  { code: "+212", flag: "🇲🇦", name: "Morocco", ar: "المغرب" },
  { code: "+258", flag: "🇲🇿", name: "Mozambique", ar: "موزمبيق" },
  { code: "+95", flag: "🇲🇲", name: "Myanmar", ar: "ميانمار" },
  { code: "+264", flag: "🇳🇦", name: "Namibia", ar: "ناميبيا" },
  { code: "+674", flag: "🇳🇷", name: "Nauru", ar: "ناورو" },
  { code: "+977", flag: "🇳🇵", name: "Nepal", ar: "نيبال" },
  { code: "+31", flag: "🇳🇱", name: "Netherlands", ar: "هولندا" },
  { code: "+64", flag: "🇳🇿", name: "New Zealand", ar: "نيوزيلندا" },
  { code: "+505", flag: "🇳🇮", name: "Nicaragua", ar: "نيكاراغوا" },
  { code: "+227", flag: "🇳🇪", name: "Niger", ar: "النيجر" },
  { code: "+234", flag: "🇳🇬", name: "Nigeria", ar: "نيجيريا" },
  { code: "+389", flag: "🇲🇰", name: "North Macedonia", ar: "مقدونيا الشمالية" },
  { code: "+47", flag: "🇳🇴", name: "Norway", ar: "النرويج" },
  { code: "+92", flag: "🇵🇰", name: "Pakistan", ar: "باكستان" },
  { code: "+680", flag: "🇵🇼", name: "Palau", ar: "بالاو" },
  { code: "+970", flag: "🇵🇸", name: "Palestine", ar: "فلسطين" },
  { code: "+507", flag: "🇵🇦", name: "Panama", ar: "بنما" },
  { code: "+675", flag: "🇵🇬", name: "Papua New Guinea", ar: "بابوا غينيا الجديدة" },
  { code: "+595", flag: "🇵🇾", name: "Paraguay", ar: "باراغواي" },
  { code: "+51", flag: "🇵🇪", name: "Peru", ar: "بيرو" },
  { code: "+63", flag: "🇵🇭", name: "Philippines", ar: "الفلبين" },
  { code: "+48", flag: "🇵🇱", name: "Poland", ar: "بولندا" },
  { code: "+351", flag: "🇵🇹", name: "Portugal", ar: "البرتغال" },
  { code: "+40", flag: "🇷🇴", name: "Romania", ar: "رومانيا" },
  { code: "+250", flag: "🇷🇼", name: "Rwanda", ar: "رواندا" },
  { code: "+1869", flag: "🇰🇳", name: "Saint Kitts and Nevis", ar: "سانت كيتس ونيفيس" },
  { code: "+1758", flag: "🇱🇨", name: "Saint Lucia", ar: "سانت لوسيا" },
  { code: "+1784", flag: "🇻🇨", name: "Saint Vincent", ar: "سانت فنسنت" },
  { code: "+685", flag: "🇼🇸", name: "Samoa", ar: "ساموا" },
  { code: "+378", flag: "🇸🇲", name: "San Marino", ar: "سان مارينو" },
  { code: "+239", flag: "🇸🇹", name: "Sao Tome and Principe", ar: "ساو تومي وبرينسيبي" },
  { code: "+221", flag: "🇸🇳", name: "Senegal", ar: "السنغال" },
  { code: "+381", flag: "🇷🇸", name: "Serbia", ar: "صربيا" },
  { code: "+248", flag: "🇸🇨", name: "Seychelles", ar: "سيشل" },
  { code: "+232", flag: "🇸🇱", name: "Sierra Leone", ar: "سيراليون" },
  { code: "+65", flag: "🇸🇬", name: "Singapore", ar: "سنغافورة" },
  { code: "+421", flag: "🇸🇰", name: "Slovakia", ar: "سلوفاكيا" },
  { code: "+386", flag: "🇸🇮", name: "Slovenia", ar: "سلوفينيا" },
  { code: "+677", flag: "🇸🇧", name: "Solomon Islands", ar: "جزر سليمان" },
  { code: "+252", flag: "🇸🇴", name: "Somalia", ar: "الصومال" },
  { code: "+27", flag: "🇿🇦", name: "South Africa", ar: "جنوب أفريقيا" },
  { code: "+211", flag: "🇸🇸", name: "South Sudan", ar: "جنوب السودان" },
  { code: "+34", flag: "🇪🇸", name: "Spain", ar: "إسبانيا" },
  { code: "+94", flag: "🇱🇰", name: "Sri Lanka", ar: "سريلانكا" },
  { code: "+249", flag: "🇸🇩", name: "Sudan", ar: "السودان" },
  { code: "+597", flag: "🇸🇷", name: "Suriname", ar: "سورينام" },
  { code: "+46", flag: "🇸🇪", name: "Sweden", ar: "السويد" },
  { code: "+41", flag: "🇨🇭", name: "Switzerland", ar: "سويسرا" },
  { code: "+963", flag: "🇸🇾", name: "Syria", ar: "سوريا" },
  { code: "+886", flag: "🇹🇼", name: "Taiwan", ar: "تايوان" },
  { code: "+992", flag: "🇹🇯", name: "Tajikistan", ar: "طاجيكستان" },
  { code: "+255", flag: "🇹🇿", name: "Tanzania", ar: "تنزانيا" },
  { code: "+66", flag: "🇹🇭", name: "Thailand", ar: "تايلاند" },
  { code: "+670", flag: "🇹🇱", name: "Timor-Leste", ar: "تيمور الشرقية" },
  { code: "+228", flag: "🇹🇬", name: "Togo", ar: "توغو" },
  { code: "+676", flag: "🇹🇴", name: "Tonga", ar: "تونغا" },
  { code: "+1868", flag: "🇹🇹", name: "Trinidad and Tobago", ar: "ترينيداد وتوباغو" },
  { code: "+216", flag: "🇹🇳", name: "Tunisia", ar: "تونس" },
  { code: "+90", flag: "🇹🇷", name: "Turkey", ar: "تركيا" },
  { code: "+993", flag: "🇹🇲", name: "Turkmenistan", ar: "تركمانستان" },
  { code: "+688", flag: "🇹🇻", name: "Tuvalu", ar: "توفالو" },
  { code: "+256", flag: "🇺🇬", name: "Uganda", ar: "أوغندا" },
  { code: "+380", flag: "🇺🇦", name: "Ukraine", ar: "أوكرانيا" },
  { code: "+44", flag: "🇬🇧", name: "United Kingdom", ar: "المملكة المتحدة" },
  { code: "+598", flag: "🇺🇾", name: "Uruguay", ar: "أوروغواي" },
  { code: "+998", flag: "🇺🇿", name: "Uzbekistan", ar: "أوزبكستان" },
  { code: "+678", flag: "🇻🇺", name: "Vanuatu", ar: "فانواتو" },
  { code: "+58", flag: "🇻🇪", name: "Venezuela", ar: "فنزويلا" },
  { code: "+84", flag: "🇻🇳", name: "Vietnam", ar: "فيتنام" },
  { code: "+967", flag: "🇾🇪", name: "Yemen", ar: "اليمن" },
  { code: "+260", flag: "🇿🇲", name: "Zambia", ar: "زامبيا" },
  { code: "+263", flag: "🇿🇼", name: "Zimbabwe", ar: "زيمبابوي" },
];

/**
 * Split a full phone string ("+96566123456") into { code, number } using the
 * longest matching dial code. Falls back to Kuwait when nothing matches.
 */
export const splitDialCode = (full) => {
  const raw = (full || "").trim();
  if (!raw) return { code: "+965", number: "" };
  let best = null;
  for (const c of DIAL_CODES) {
    if (raw.startsWith(c.code) && (!best || c.code.length > best.code.length)) {
      best = c;
    }
  }
  if (best) return { code: best.code, number: raw.slice(best.code.length) };
  return { code: "+965", number: raw.replace(/^\+/, "") };
};

/**
 * Build the E.164 number Firebase requires from a dial code and whatever the
 * student typed into the national field.
 *
 * THE TRUNK ZERO
 * --------------
 * Most countries write their own numbers with a leading "0" that exists only
 * for dialling domestically — Egypt 0100 123 4567, the UK 07700 900123,
 * Jordan 07 9012 3456. That zero is a trunk prefix, not part of the number,
 * and E.164 has no place for it: the real number is +201001234567, not
 * +2001001234567.
 *
 * Kuwait and the other Gulf codes this app was built against have no trunk
 * prefix, so nobody typed one and the bug stayed hidden. The first Egyptian
 * student to type their number the way they always write it produced an
 * unroutable number.
 *
 * Only leading zeros are removed, and only from the national part — a dial
 * code is never affected, and a number that is all zeros returns empty rather
 * than something that looks valid.
 *
 * @param {string} code     dial code including the plus, e.g. "+20"
 * @param {string} national what the student typed, digits or not
 * @returns {string} E.164, or "" when there is nothing usable
 */
export const toE164 = (code, national) => {
  const digits = String(national || "").replace(/\D/g, "").replace(/^0+/, "");
  if (!digits) return "";
  const dial = String(code || "").trim();
  return `${dial.startsWith("+") ? dial : `+${dial}`}${digits}`;
};

export default DIAL_CODES;
